import type { LucideIcon } from "lucide-react";

import { GravunCard } from "./SectionCard";

/**
 * KPI card, reference style:
 *   REVENUE            (icon)
 *   $15k
 *   From paid invoices
 * Small muted uppercase label, strong metric, small muted helper text.
 * Pass value ", " when the metric's source module doesn't exist yet, never
 * fabricate numbers.
 */
export const MetricCard = ({
  label,
  value,
  helper,
  icon: Icon,
}: {
  label: string;
  value: string;
  helper: string;
  icon?: LucideIcon;
}) => (
  <GravunCard className="px-4 py-3.5">
    <div className="flex items-center justify-between gap-2">
      <span className="text-[10.5px] font-semibold uppercase tracking-[0.09em] text-muted-foreground">
        {label}
      </span>
      {Icon ? (
        <Icon
          className="size-3.5 text-muted-foreground/70"
          strokeWidth={1.75}
        />
      ) : null}
    </div>
    <div className="mt-1.5 text-[26px] font-semibold leading-8 tracking-tight text-foreground">
      {value}
    </div>
    <div className="mt-0.5 truncate text-[12px] leading-4 text-muted-foreground">
      {helper}
    </div>
  </GravunCard>
);
